(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ode-kategorien"] && !Shopify.designMode) return;
  try {
    (function () {
  function init(root) {
    if (root.dataset.odeKatBereit) return; root.dataset.odeKatBereit = '1';
    if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var liste = root.querySelector('[data-ode-kat-liste]'), v = root.querySelector('[data-ode-kat-vorschau]'), img = root.querySelector('[data-ode-kat-img]');
    var zeilen = [].slice.call(root.querySelectorAll('[data-ode-kat-zeile]'));
    if (!liste || !v || !img || !zeilen.length) return;
    var mx = 0, my = 0, cx = 0, cy = 0, an = false, raf = null, akt = '';
    zeilen.forEach(function (z, i) {
      var zeig = function () {
        var src = z.dataset.bild; if (!src) { v.classList.remove('ist-sichtbar'); return; }
        v.classList.add('ist-sichtbar');
        v.style.setProperty('--ode-kat-kippe', i % 2 ? '4deg' : '-5deg');
        if (src !== akt) { akt = src; img.src = src; img.style.animation = 'none'; void img.offsetWidth; img.style.animation = ''; }
      };
      z.addEventListener('mouseenter', zeig); z.addEventListener('focus', zeig);
    });
    var tick = function () { cx += (mx - cx) * 0.2; cy += (my - cy) * 0.2; v.style.transform = 'translate(' + cx + 'px,' + cy + 'px)'; raf = an ? requestAnimationFrame(tick) : null; };
    liste.addEventListener('mouseenter', function (e) { an = true; mx = cx = e.clientX; my = cy = e.clientY; if (!raf) raf = requestAnimationFrame(tick); });
    liste.addEventListener('mousemove', function (e) { mx = e.clientX; my = e.clientY; });
    liste.addEventListener('mouseleave', function () { an = false; v.classList.remove('ist-sichtbar'); });
  }
  var alle = function () { document.querySelectorAll('.ode-kat').forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
  document.addEventListener('shopify:section:load', alle);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ode-marken"] && !Shopify.designMode) return;
  try {
    (function () {
  function init(root) {
    if (root.dataset.odeMarkReady) return;
    root.dataset.odeMarkReady = 'true';

    var liste = root.querySelector('[data-ode-mark-liste]');
    var preview = root.querySelector('[data-ode-mark-preview]');
    var img = root.querySelector('[data-ode-mark-preview-img]');
    var zeilen = Array.prototype.slice.call(root.querySelectorAll('[data-ode-mark-zeile]'));
    if (!liste || !preview || !img || !zeilen.length) return;

    // Nur Desktop: auf Touch-Geraeten bleibt es bei der ruhigen Textliste.
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var mouseX = 0;
    var mouseY = 0;
    var curX = 0;
    var curY = 0;
    var active = false;
    var raf = null;
    var currentSrc = '';

    zeilen.forEach(function (zeile, index) {
      // Leichte, alternierende Schieflage - jede Zeile bekommt ihre eigene Kippe.
      zeile.style.setProperty('--ode-mark-index', index);
      zeile.addEventListener('mouseenter', function () {
        activate(zeile, index);
      });
      zeile.addEventListener('focus', function () {
        activate(zeile, index);
      });
    });

    liste.addEventListener('mouseenter', start);
    liste.addEventListener('mouseleave', stop);
    liste.addEventListener('mousemove', onMove);

    function onMove(event) {
      mouseX = event.clientX;
      mouseY = event.clientY;
    }

    function start(event) {
      active = true;
      mouseX = event.clientX;
      mouseY = event.clientY;
      // Ohne diesen Sprung wuerde das erste Bild jedes Mal aus der Ecke oben links
      // angeflogen kommen, statt direkt beim Zeiger zu erscheinen.
      curX = mouseX;
      curY = mouseY;
      preview.classList.add('ode-mark__preview--sichtbar');
      if (!raf) raf = window.requestAnimationFrame(tick);
    }

    function stop() {
      active = false;
      preview.classList.remove('ode-mark__preview--sichtbar');
    }

    function activate(zeile, index) {
      var src = zeile.dataset.bild;
      if (!src) return;
      img.alt = zeile.dataset.bildAlt || '';
      preview.style.setProperty(
        '--ode-mark-kippe',
        index % 2 === 0 ? '-4deg' : '3deg'
      );
      if (src !== currentSrc) {
        currentSrc = src;
        img.src = src;
        // Reflow erzwingen, damit die Eintritts-Animation bei jedem Zeilenwechsel
        // neu von vorn beginnt statt einfach zu ueberspringen.
        img.style.animation = 'none';
        void img.offsetWidth;
        img.style.animation = '';
      }
    }

    function tick() {
      // Sanftes Nachziehen statt hartem Sprung - macht aus einer Mausposition eine Bewegung.
      curX += (mouseX - curX) * 0.2;
      curY += (mouseY - curY) * 0.2;
      preview.style.transform = 'translate(' + curX + 'px, ' + curY + 'px)';
      if (active) {
        raf = window.requestAnimationFrame(tick);
      } else {
        raf = null;
      }
    }
  }

  function initAll() {
    document.querySelectorAll('.ode-mark').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
  } catch(e) { console.error(e); }
})();

})();
